<roots-page-header [toolTip]="toolTip" [title]="title" [loading]="loading">
</roots-page-header>
<div class="col-12">
  @if (coordinates) {
    <div>
      <app-asset-map [installs]="installs" [coordinates]="coordinates"></app-asset-map>
    </div>
  }
  <div>
    @if (scout) {
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xxl-6" style="float: left;">
        @if (firmwareVersion) {
          <mat-card appearance="outlined">
            <mat-card-actions>
              <app-scout-interval [scoutId]="scoutId" [sendCounterValue]="sendInterval" [pollCounterValue]="pollInterval"
                [scout]="scout" [firmwareVersion]="firmwareVersion">
              </app-scout-interval>
            </mat-card-actions>
          </mat-card>
        }
        <mat-card appearance="outlined">
          <h3 class="text label-header-text">Details</h3>
          <hr />
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput placeholder="Name" [(ngModel)]="scout.basicName" disabled required />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Description</mat-label>
            <input matInput placeholder="Description" [(ngModel)]="scout.basicDescription" disabled required />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Statistics</mat-label>
            <input matInput placeholder="Statistics" [(ngModel)]="scout.statistics" disabled required />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Interval Sync Status</mat-label>
            <input matInput placeholder="Interval sync status" [(ngModel)]="scout.intervalSyncStatus" disabled />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Mode</mat-label>
            <input matInput placeholder="Mode" [(ngModel)]="scout.mode" disabled required />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Created At</mat-label>
            <input matInput placeholder="Created At" [(ngModel)]="scout.createdAt" disabled required />
          </mat-form-field>
          <button mat-raised-button type="submit" style="max-width: fit-content" color="primary" disabled>
            Update
          </button>
        </mat-card>
        @if (scoutdata) {
          <mat-accordion class="col-12">
            <mat-expansion-panel>
              <mat-expansion-panel-header style="padding-left: 15px; padding-right: 15px;">
                <mat-panel-title style="font-size: 25px; font-weight: 500;"> Technical Details </mat-panel-title>
                <mat-panel-description style="font-size: 1.2rem; justify-content: space-between; align-items: center;">
                  Asset Model and Info
                  <mat-icon>settings</mat-icon>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <!-- Asset Model -->
              @if (scoutdata != null && scoutdata.assetModelInfo) {
                <mat-card appearance="outlined">
                  <div style="overflow: auto; overflow-wrap: break-word">
                    <h3 class="text label-header-text">
                      <mat-icon>devices</mat-icon>
                      Asset Model:
                    </h3>
                    <hr>
                      <p class="text dashboard-text" style="margin: 0px;">
                        Asset Kind Codes: {{scoutdata.assetModelInfo.assetKindCodes}}
                      </p>
                      <ul style="text-align: center; list-style: none;">
                        @for (capability of scoutdata.assetModelInfo.capabilities; track capability) {
                          <li>
                            <p class="text dashboard-text" style="margin: 0px;">
                              <b>{{ capability.code }}: {{ capability.value }}</b>
                            </p>
                          </li>
                        }
                      </ul>
                    </div>
                  </mat-card>
                }
                <!-- INFO -->
                @if (scoutdata != null && scoutdata.healthSensorId) {
                  <mat-card appearance="outlined">
                    <h3 class="text label-header-text">
                      <mat-icon>info</mat-icon>
                      Info:
                    </h3>
                    <hr />
                    <ul style="overflow: auto; overflow-wrap: break-word">
                      <li class="text dashboard-text">
                        Health Sensor: {{scoutdata.healthSensorId}}
                        <a mat-button (click)="navigateToHealth(scoutdata.healthSensorId)" style="float: right;">
                          <mat-icon>search</mat-icon>
                        </a>
                      </li>
                      <li class="text dashboard-text">
                        Holding: {{scoutdata.holdingId}}
                        <!-- <a mat-button (click)="navigateToHolding(scoutdata.holdingId)" style="float: right;">
                        <mat-icon>search</mat-icon>
                      </a> -->
                    </li>
                    <li class="text dashboard-text">
                      Notification Count: {{scoutdata.notificationConfirmationCount}}
                    </li>
                  </ul>
                </mat-card>
              }
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    }

    @if (scout) {
      <app-notes [entityId]="scoutId" [entityCode]="scout.code" [entityType]="'Scout'" [notes]="notes"
        (noteAdded)="noteAdded($event)">
      </app-notes>
    }

    @if (scoutdata) {
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xxl-6" style="float: left">
        <mat-card appearance="outlined">
          @if (scoutdata) {
            <div>
              <h3 class="text label-header-text">
                <mat-icon style="color: green;">mobile_friendly</mat-icon>
                Scout Data
              </h3>
              <hr>
                <p class="text dashboard-text" style="text-align: center; margin: 0px;">
                  {{scoutdata.name}}
                </p>
                <p class="text small-text" style="text-align: center; margin: 0px;">
                  {{scoutdata.description}}
                </p>
                <p class="text dashboard-text" style="margin: 0px;">
                  GPS:
                </p>
                @if (scoutdata.coordinateLatitude) {
                  <p class="text dashboard-text" style="margin: 0px;">
                    [Latitude: {{scoutdata.coordinateLatitude.toFixed(5)}}, Longitude:
                    {{scoutdata.coordinateLongitude.toFixed(5)}}, Altitude:
                    {{scoutdata.coordinateAltitude}}]
                  </p>
                } @else {
                  <p class="text small-text" style="margin: 0px; color: red;">
                    No GPS data found (Map set to your location)
                  </p>
                }
              </div>
            } @else {
              <mat-icon style="color: red;">mobile_off</mat-icon>
              No Scout Data
              <p class="text dashboard-text">
                If unit is on and sending, please check to make sure all the correct assets are assigned as well.
              </p>
            }
          </mat-card>
          <!-- Firmware -->
          @if (scoutdata.firmwareModelInfo) {
            <mat-card appearance="outlined">
              <h3 class="text label-header-text">
                <mat-icon>important_devices</mat-icon>
                Firmware:
              </h3>
              <hr>
                <ul style="text-align: center; list-style: none;">
                  <li class="text dashboard-text">
                    Name: <b>{{scoutdata.firmwareModelInfo.name}}</b>
                    <a mat-button (click)="navigateToFirmware(scoutdata.firmwareModelInfo.id)" style="float: right;">
                      <mat-icon>search</mat-icon>
                    </a>
                  </li>
                  <li class="text dashboard-text">
                    Version: <b>{{scoutdata.firmwareModelInfo.version}}</b>
                  </li>
                  <li class="text dashboard-text">
                    Description: <b>{{scoutdata.firmwareModelInfo.description}}</b>
                  </li>
                </ul>
              </mat-card>
            }
          </div>
        }
        @if (scoutdata) {
          <app-roots-details-data-list [data]="scoutdata.sensors" [prop_1]="'name'" [prop_2]="'assetName'"
            [prop_3]="'assetCode'" [prop_4]="'id'" [type]="3" [icon]="'widgets'" [title]="'Sensors'">
          </app-roots-details-data-list>
        }
      </div>
    </div>